<template>
  <div>
    <div id="login">
      <a @click="redirectBackIfPresent()" class="no-deco back-button-login cursor-pointer" :class="isPhone ? 'raleway-semi-p14 px-3 mb-2' : 'raleway-semi-p24 mb-5'"> < Retour </a>
      <div v-if="forgotPassword" class="content">
        <div class="modal-content-form">
          <div class="header-modal">
            <h2 class="merriweather-reg-26">Mot de passe oublié</h2>
          </div>
          <div v-if="sent" class="form-signup raleway-reg-p15">
            <div class="form-item">
              <p>Nous venons d’envoyer un e-mail contenant des instructions ainsi qu’un lien pour réinitialiser votre mot de passe à l’adresse {{this.forgotMail}}. Il est possible que vous deviez patienter quelques minutes avant de le recevoir.</p>
            </div>
            <a href="/" class="hortense-btn-primary">Retour à l'accueil</a>
          </div>

          <div v-else class="form-signup raleway-reg-p15">
            <div class="form-item">
              <label for="name">Saisissez votre adresse email</label>
              <input v-model="forgotMail" type="text">
            </div>
            <div>
            </div>
            <button @click="sendForget" class="hortense-btn-primary">Envoyer le lien de réinitialisation</button>
          </div>
        </div>

      </div>
      <div v-else class="content">      
        <div class="content-form">
          <div class="header-modal headline">
            <p :class="isPhone ? 'merriweather-reg-28 pt-3 pb-0' : 'merriweather-reg-40' ">Connectez-vous à votre compte Hortense</p>
          </div>
          <div class="form-signup raleway-reg-p15" :class="isPhone? '' : ' pt-4'">
            <p style='color: red;' v-if='errorMessage'>invalid email or password</p>
            <div class="form-item">
              <label for="name" :class="isPhone ? 'raleway-medi-p14' : 'raleway-medi-p25'">E-mail</label>
              <input v-model="userInfo.email" type="text" />
            </div>
            <div class="form-item">
              <label for="name" :class="isPhone ? 'raleway-medi-p14' : 'raleway-medi-p25'">Mot de passe</label>
              <input v-model="userInfo.password" type="password" />
            </div>
            <button @click="UserBasicInfo" class="hortense-btn-primary mt-4" :class="isPhone ? 'raleway-bold-p14' : 'raleway-bold-p25'">SE CONNECTER</button>
            <a style="cursor: pointer" @click="forgotPassword = true"  class="link-hortense pt-4" :class="isPhone ? 'raleway-reg-p10' : 'raleway-reg-p20'">Mot de passe oublié?</a>
          </div>
        </div>
        <div class="social-connection divider">
          <p class="mt-2 mx-4" :class="isPhone ? 'raleway-reg-p15' : 'raleway-reg-p20'">ou</p>
        </div>
        <div class="social-connection-btn pt-4">
          <div class="social-btn">
            <img src="https://hortense-vue.s3.eu-west-3.amazonaws.com/static/google.png" v-set-alt>
            <a :href="'/users/auth/google_oauth2'" :class="isPhone ? 'raleway-semi-p15' : 'raleway-semi-p20'">Se connecter avec Google</a>
          </div>
        </div>
        <div class="social-connection-btn">
          <div class="social-btn fb-social-btn">
            <img src="https://hortense-vue.s3.eu-west-3.amazonaws.com/static/facebook.png" v-set-alt>
            <a :href="'/users/auth/facebook'" :style="'color: #FFFFFF;'" :class="isPhone ? 'raleway-semi-p15' : 'raleway-semi-p20'">Se connecter avec Facebook</a>
          </div>
        </div>
        <div class="social-connection divider">
          <p class="mt-2 mx-4" :class="isPhone ? 'raleway-reg-p15' : 'raleway-reg-p20'">ou</p>
        </div>
        <p class="vous mb-4" :class="isPhone ? 'raleway-semi-p14' : 'raleway-semi-p20'">Vous n'avez pas de compte ?</p>
        <button @click="visitLink('/inscription')" class="hortense-btn-primary-creer mb-4">
          CRÉER UN COMPTE
        </button>
      </div>
    </div>
    <div class="promo-page pt-5" :class="isPhone ? '' : 'px-5'">
      <p class=" text-center" :class="isPhone ? 'merriweather-reg-24' : 'merriweather-reg-40'">Voyagez comme un invité privilégié</p>
      <p class="text-center" :class="isPhone ? 'raleway-reg-p15' : 'merriweather-light-24'">
        Profitez des services exclusifs spécialement conçus pour vous.
      </p>
      
      <div class="slider-wrapper pt-4 position-relative">
        <div class="d-flex flex-row flex-nowrap" id="offers-scroller" style="overflow: scroll; overflow-y: hidden">
          <div
            v-for="(offer, index) in visibleOffers"
            :key="index"
            class="offer"
          >
            <div class="zoom-img-container">
              <img :src="offer.image" :alt="offer.title" class="offer-image zoom-img" />
            </div>
            <p class="offer-title" :class="isPhone ? 'raleway-semi-p15' : 'raleway-bold-p16'">{{ offer.title }}</p>
          </div>
        </div>
        <div class="previous-slide-button" @click="scroll_left">
          <button class="nav-button left mb-5">
            &lt;
          </button>
        </div>
        <div class="next-slide-button" @click="scroll_right">
          <button class="nav-button right mb-5">
            &gt;
          </button>
        </div>
      </div>
      
      
      <p class="text-center address-p" :class="isPhone ? 'raleway-reg-p15' : 'raleway-reg-p15 pt-4'">
        Chaque adresse de notre sélection est minutieusement choisie pour vous offrir un accueil d’exception. Réservez dès maintenant sur notre site et profitez d'une expérience unique.
      </p>

      <button @click="visitLink('/programme-fidelite-club-hortense')" class="cta-button mt-4">
        EN SAVOIR PLUS
      </button>
      <p class=" disclaimer pt-4" :class="isPhone ? 'raleway-reg-p8' : 'raleway-reg-p15'">
        *Chaque hébergement propose des services exclusifs soigneusement sélectionnés. Consultez la page dédiée à l’hébergement pour découvrir les offres disponibles. Les détails peuvent varier d’un établissement à l’autre.
      </p>
    </div>
    <Modalsignup v-if="showModal" @close="showModal = false" />
  </div>
</template>

<script>
    import fetcher from 'packs/shared/api.js';
    import Modalsignup from '../../components/modals/Modalsignup.vue';

  export default{
    name: 'LoginForm',
    props: {
      redirectUrl: {
        type: String,
        required: true
      }
    },
    components: {
      Modalsignup
    },
    data() {
      return {
        userInfo: {
          email: '',
          password: ''
        },
        showModal: false,
        errorMessage: false,
        forgotPassword: false,
        forgotMail: '',
        sent: false,
        currentStartIndex: 0,
        offers: [
          { title: "Massage offert", image: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Massage+gratuit+service+exclusif+Hortense.jpg" },
          { title: "Petit déjeuner offert", image: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Petit+de%CC%81j+offert+service+exclusif+Hortense.jpg" },
          { title: "Dîner offert", image: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Di%CC%82ner+offert+service+exclusif+Hortense.jpg"},
          { title: "Surclassement de chambre", image: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Surclassement+de+chambre+service+exclusif+Hortense.jpg" },
          { title: "Bouteille de champagne" ,image: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Bouteille+de+champagne+service+exclusif+Hortense.jpg" },
          { title: "Dégustation de vin", image: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/De%CC%81gustation+de+vin+service+exclusif+Hortense.jpg" },
          { title: "Verre de bienvenue", image: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Verre+de+bienvenue+service+exclusif+Hortense.jpg" }
        ],
      };
    },
    computed: {
      visibleOffers() {
        return this.offers;
      },
      isPhone() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
      },
      itemsPerPage() {
        return this.isPhone ? 2 : 4;
      }
    },
    methods: {
      redirectBackIfPresent() {
        if (window.history.length > 1) {
          window.history.back();
        } else {
          window.location.href = '/';
        }
      },
      visitLink(link) {
        window.open(link, '_blank');
      },
      async UserBasicInfo(){
        try {
          const res = await fetcher.post('/users/sign_in', {
            user: {
              email: this.userInfo.email,
              password: this.userInfo.password,
              role: 'customer'
            }
          })
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'login',
            method: 'email_password',
          });
          this.$emit('close', res.data)
          location.replace(this.redirectUrl);
        } catch(e) {
          this.errorMessage = true;
        }
      },
      async sendForget(){
        try {
          const res = await fetcher.post('/send-reset-password', {
            email: this.forgotMail
          })
          console.log(res)
        } catch(e){
          console.log(e)
        }
        this.sent = true
      },
      setUser(user){
        this.user = user;
        this.showModallogin = false;
      },
      autoScroll() {
        const scroller = document.getElementById('offers-scroller');
        if (!scroller) return;
        const step = 1;
        let maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;

        const frame = () => {
          if (scroller.scrollLeft >= maxScrollLeft) {
            scroller.scrollLeft = 0;
            maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;
          } else {
            scroller.scrollLeft += step;
          }
          requestAnimationFrame(frame);
        }
        frame();
      },
      scroll_left() {
        let content = document.querySelector("#offers-scroller");
        content.scrollLeft -= 220;
      },
      scroll_right() {
        let content = document.querySelector("#offers-scroller");
        content.scrollLeft += 220;
      }
    },
    mounted() {
      console.log(this.redirectUrl)
      this.autoScroll();
    }
  }
</script>

<style lang="scss" scoped>

.form-input {
  border: 1px solid black;

  &:focus {
    outline: none;
  }
}

#login {
  height: auto;
  display: grid;
  background: url("https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/connexion-hortense.jpeg");
  background-size: cover;
  padding: 135px 0;

  @media  screen and (max-width: 768px) {
    padding: 100px 34px 34px 40px;
    
  }
}

.headline {
  text-align: center;
  line-height: 1.2;
  word-spacing: 2px;
}

.social-btn {
  border: 1px solid #707070;
  width: 427px;
  height: 60px;

  @media screen and (max-width: 768px) {
    width: 97%;
  }
}

.fb-social-btn {
  background: #3B5998;
}

.divider {
  display: flex;
  align-items: center;
  text-align: center;
  width: 75%;
  margin-left: 15%;
  position: relative;

  @media screen and (max-width: 768px) {
    width: 100% !important;
    margin-left: 0 !important;
  }
}

#login .hortense-btn-primary-creer{
  width: 427px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;
  align-items: center;
  color: white;
  text-decoration: none;
  background-color: #3B6152;
  padding: 16px 36px;
  text-transform: uppercase;
  margin-left: auto;
  margin-right: auto;
  font-size: 13px;
  font-family: $Raleway;
  font-weight: 700;

  @media screen and (max-width: 768px) {
    width: 85%;
    font-size: 14px;
    padding: 0 1rem;
    height: 6vh !important;
  }

  @media screen and (max-width: 480px) {
    width: 100%;
    font-size: 14px;
    padding: 0;
    height: 6vh !important;
  }
}

.divider::before,
.divider::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #707070; /* Adjust color */
  margin: 0 10px;
}

.divider span {
  color: black; /* Adjust text color */
}

.vous {
  text-align: center;
  color: #090808;
  opacity: 1;
}

#login .social-connection-btn {
  @media screen and (max-width: 768px) {
    padding: 0 1rem;
  }

  @media screen and (max-width: 480px) {
    width: 100%;
    padding: 0;
  }
}

#login .social-connection-btn .social-btn a {
  margin: 11px;
  letter-spacing: 0px;

  font-family: $Raleway;
  font-size: 20px;

  @media screen and (max-width: 768px) {
    font-size: 15px;
  }
}

#login .social-connection-btn .social-btn img {
  width: 40px;
  height: 40px;

  @media screen and (max-width: 768px) {
    width: 36px;
    height: 36px;   
  }
}

#login .social-connection-btn .social-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 36px;
  width: 427px;
  border: 1px solid #707070;
  box-shadow: unset;
  border-radius: unset;

  @media screen and (max-width: 768px) {
    width: 97%;
    padding: 0;
  }
}

#login .social-connection-btn{
  margin-bottom: 1rem;

  @media screen and (max-width: 768px) {
    margin-bottom: 8px;
  }
}
#login .social-connection {
  display: flex;
  flex-direction: row;
  width: 70%;
  margin-left: 15%;

  @media screen and (max-width: 768px) {
    padding: 0;
    margin: unset;
    width: 97% !important;
  }
}

#login .form-signup {
  width: 100%;
  max-width: 100%;
  padding: 0 1rem;
  box-sizing: border-box;

  @media screen and (max-width: 480px) {
    padding: 0; 
  }
}

#login .form-signup .form-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 1.5rem;
  width: 100%;

  @media screen and (max-width: 768px) {
    margin-bottom: 10px;
  }
}

#login .form-signup label {
  margin-bottom: 0.5rem;
  white-space: normal;
  word-break: break-word;
  color: #333;
}

#login .form-signup input {
  padding: 0.75rem;
  border: 1px solid #090808;
  box-sizing: border-box;
  width: 675px;

  @media screen and (max-width: 768px) {
    width: 100%;
    height: 44px;
    padding-left: 4%;
    padding-right: 4%;
  }
}

.content {
  width: 911px !important;

  @media screen and (max-width: 768px) {
    width: 100% !important;
    overflow-y: hidden;
  }
}

.content-form {
  padding-bottom: 1rem !important;

  @media screen and (max-width: 768px) {
    padding: 0 !important;
    height: auto !important;
  }
}

.promo-page {
  max-width: 1968px;
  background: #f7f7f7;
  margin: 0 auto;
  padding: 20px;
  text-align: center;
}

.description, .subtext {
  color: #090808;
  margin-bottom: 20px;
}

.disclaimer {
  color: #090808;
  text-align: start;
}

.offers {
  display: flex;
  justify-content: start;
  align-items: center; /* vertically center if needed */
  flex-wrap: nowrap;
  gap: 20px;
  overflow: hidden;
}

.offer {
  flex: 0 0 auto;
  width: fit-content;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 10px;

  @media screen and (max-width: 768px) {
    padding: 0;
  }

  img {
    @media screen and (max-width: 768px) {
      width: 250px;
      height: 300px;
    }
  }
}

.slider-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  overflow: hidden;
  margin: 20px 0;
  background: #F7F7F7 0% 0% no-repeat padding-box;
  height: unset;
  padding: 0 60px;

  @media screen and (max-width: 768px) {
    padding: 0 50px;
  }

  @media screen and (max-width: 480px) {
    padding: 0 30px;
    gap: 5px;
  }
}

.previous-slide-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 10px;
  z-index: 10;

  @media screen and (max-width: 768px) {
    left: 5px;
  }

  @media screen and (max-width: 480px) {
    left: 2px;
  }

  button {
    font-size: 3.5rem;
    color: #707070;
    border: none;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    @media screen and (max-width: 768px) {
      font-size: 2rem;
      width: 40px;
      height: 40px;
    }

    @media screen and (max-width: 480px) {
      font-size: 1.5rem;
      width: 35px;
      height: 35px;
    }

    &:hover {
      color: #3B6152;
    }
  }
}

.next-slide-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
  z-index: 10;

  @media screen and (max-width: 768px) {
    right: 5px;
  }

  @media screen and (max-width: 480px) {
    right: 2px;
  }

  button {
    font-size: 3.5rem;
    color: #707070;
    border: none;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    @media screen and (max-width: 768px) {
      font-size: 2rem;
      width: 40px;
      height: 40px;
    }

    @media screen and (max-width: 480px) {
      font-size: 1.5rem;
      width: 35px;
      height: 35px;
    }

    &:hover {
      color: #3B6152;
    }
  }
}


.offer-image {
  width: 360px;
  height: 428px;
  max-width: 100%;
  object-fit: cover;

  @media screen and (max-width: 768px) {
    width: 100%;
    height: 206px;
    max-width: calc(100% - 20px);
  }

  @media screen and (max-width: 480px) {
    max-width: calc(100% - 10px);
  }
}

.offer-title {
  margin-top: 10px;
  text-transform: uppercase;
  height: 50px;
}

.cta-button {
  background-color: #3B6152;;
  color: white;
  padding: .8rem 2rem;
  border: none;
  cursor: pointer;
  margin-top: 20px;
  text-align: center;
  font-family: $Raleway;
  font-weight: 700;
  font-size: 13px;
  text-decoration: none;
  transition: background-color .3s;

  @media screen and (max-width: 768px) {
    padding: .8rem 2rem;
    font-size: 14px;
  }
}

.learn-more {
  color: #090808;
  text-decoration: underline;
  font-size: 1rem;
  cursor: pointer;
  margin-top: 10px;
}

.learn-more:hover {
  text-decoration: underline;
}

.link-hortense {
  color: #3B6152;
}

.address-p {
  padding-left: 15%;
  padding-right: 15%;

  @media screen and (max-width: 768px) {
    padding-left: 5%;
    padding-right: 5%;
  }
}

.hortense-btn-primary {
  width: 427px !important;

  @media screen and (max-width: 768px) {
    width: 97% !important;
  }
}

.back-button-login {
  padding-left: 140px;
}
</style>
